import { UseFormReturn } from 'react-hook-form'
import { Form } from './ui/Form'
import { FormValues } from './ui/Form/model'

type DriverLicenseStepProps = {
  onSuccess: (formValues: FormValues) => void
  form: UseFormReturn<FormValues>
  isLoading: boolean
}

export function DriverLicenseStep({
  onSuccess,
  form,
  isLoading,
}: DriverLicenseStepProps) {
  return <Form onSuccess={onSuccess} form={form} isLoading={isLoading} />
}
